// SEO-friendly slug helpers for listings.
// URL pattern: /patinete/<slug>-<uuid>
// Backwards compatible: also accepts /patinete/<uuid>

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const slugify = (s: string): string =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 80)
    .replace(/^-+|-+$/g, "");

export const buildListingSlug = (l: {
  id: string;
  brand?: string | null;
  model?: string | null;
  city?: string | null;
  title?: string | null;
}): string => {
  const parts = [l.brand, l.model, l.city].filter(Boolean).join(" ");
  const base = slugify(parts || l.title || "patinete");
  return base ? `${base}-${l.id}` : l.id;
};

export const listingUrl = (l: {
  id: string;
  brand?: string | null;
  model?: string | null;
  city?: string | null;
  title?: string | null;
}): string => `/patinete/${buildListingSlug(l)}`;

/** Extract the UUID from a slug param (last 36 chars if they match UUID pattern). */
export const extractListingId = (slugOrId: string): string => {
  const m = slugOrId.match(UUID_RE);
  return m ? m[0] : slugOrId;
};
